import { Typography } from "@mui/material";
import { SmartButton as SmartButtonIcon } from "@mui/icons-material"
import FormBuilderDesign from "components/InputsDesign/FormBuilderDesign";
import { DataFields } from "./DataFields";

export default function HeaderModule({ 
  t,
  dataInstance, 
  register, 
  errors, 
  changeDataFunction, 
  setFieldImageManager, 
  openImageManager, 
  changeCompletePicker
}) {

  return (<>
    <Typography variant="h6" sx={{ display: "flex", alignItems: "center" }}><SmartButtonIcon /> &nbsp; {t('designmenu_select_option_header')}</Typography>
    <FormBuilderDesign 
      dataDields={DataFields(t)}
      dataInstance={dataInstance}
      register={register}
      errors={errors}
      changeDataFunction={changeDataFunction}
      setFieldImageManager={setFieldImageManager}
      openImageManager={openImageManager}
      changeCompletePicker={changeCompletePicker}
    />
  </>)
}